import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function splitterValidator(): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    return splitter(control.value) ? null : { splitter: control.value };
  };
}

function splitter(x: string) {
  return ALLOWED_VALUES.includes(x);
}

const ALLOWED_VALUES = [
  '0',
  '1x0',
  '1x2',
  '1x4',
  '1x8',
  '1x16',
  '1x32'
];
